import React from 'react';
import Card from '../../../core/layout/Card';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import InstructionVideoListContainer from './InstructionVideoListContainer';
import InstructionVideoListFilterContainer from './InstructionVideoListFilterContainer';

const InstructionVideoListScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        { text: 'Instruction Videos' },
      ]}
    />
    <Card
      title="Instruction Videos"
      actions={
        <Button
          type="primary"
          icon="plus"
          label="New Instruction Video"
          onClick={() => browserHistory.push('/instruction-videos/new')}
        />
      }
    >
      <InstructionVideoListFilterContainer initialFilters={props.location.query} />
      <InstructionVideoListContainer />
    </Card>
  </div>
);

export default InstructionVideoListScene;
